import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hospital-view',
  templateUrl: './hospital-view.component.html',
  styleUrls: ['./hospital-view.component.scss']
})
export class HospitalViewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
